import React from "react";

export default function Angelus() {
  return (
    <>
      <p>
        V. El Ángel del Señor <br />
        lo anunció a María. <br />
        R.Y concibió por obra <br />
        del Espíritu Santo.
        <br /> <br />
        Dios te salve, María... <br />
        Santa María... <br />
        V.He aquí la esclava <br />
        del Señor. <br />
        R. Hágase en mí según <br />
        tu palabra.
        <br /> <br />
        Dios te salve, María... <br />
        Santa María... <br />
        V. El Verbo se hizo carne. <br />
        R.Y vivió entre nosotros.
        <br />
        <br />
        Dios te salve, María... <br />
        Santa María... <br />
        V. Rogad por nosotros, <br />
        Santa Madre de Dios. <br />
        R. Para que seamos dignos <br />
        de alcanzar las promesas de Nuestro Señor Jesucristo.
        <br />
        <br />
        Amén.
        <br />
        <br />
        <strong>Oración:</strong> <br />
        Infunde, Señor tu gracia en nuestros corazones para que cuantos, por el anuncio del ángel, hemos conocido la encarnación de tu Hijo Jesucristo, por su pasión y su cruz lleguemos a la gloria de su resurrección. <br /> Por Jesucristo, Nuestro Señor, Amén
      </p>
    </>
  );
}
